import React, { useEffect, useState } from 'react'
import { showData } from '../../Utils/APIs/commonShowAPI';
export default function Index() {
    const [quarterlyList, setQuarterlyList]= useState([]);
    useEffect(()=>{
        showData(`filedService/showSurvey`,setQuarterlyList);
    }, [])
    
  return (    
    <>
        <button className='p-1 pl-5 pr-5 rounded-md absolute bottom-4 left-64 text-white bg-gray-800'>
            Back
        </button>
        <button className='p-1 pl-5 pr-5 rounded-md absolute bottom-4 right-16 text-white bg-gray-800' >
            Forward
        </button>
        <div className='overflow-auto h-[calc(100vh-8rem)]'>
            <div className="relative">
                <table className=" text-gray-500 dark:text-gray-400" style={{ position: 'relative'}}>
                    <thead className="text-xs border border-gray-150 bg-gray-800 text-gray-100 uppercase dark:bg-gray-800 dark:text-gray-400">
                        <tr>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">SaralId</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Farmer Name</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Father Name</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Block</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">District</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Pump Installed Date</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Name  of Firm</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Pump Type& Capacity</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Current Status</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Periodic Maintenance</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">submit Date</th>
                            <th  className="px-6 py-3 text-center font-semibold text-nowrap">Images</th>
                        </tr>
                    </thead>
                    {quarterlyList && quarterlyList.map((data)=>(
                        <tr className='text-center'>
                            <td className='text-center'>{data?.farmerId?.saralId}</td>
                            <td className='text-center'>{data?.farmerId?.farmerName}</td>
                            <td className='text-center'>{data?.farmerId?.fatherOrHusbandName}</td>
                            <td className='text-center'>{data?.farmerId?.block}</td>
                            <td className='text-center'>{data?.farmerId?.district}</td>
                            <td className='text-center'>
                            {/* {data?.farmerId?.installationDate} */}
                                {/* {data?.farmerId?.installationDate !== "Invalid Date" ? (()=>{
                                    const date = new Date(data?.farmerId?.installationDate) || null // Assuming installationDate is the date to format
                                    return date?.toISOString().split('T')[0]; // Extract the time part
                                })() : "N/A"} */}
                                {
                                    (() => {
                                        const rawDate = data?.farmerId?.installationDate;
                                        const date = rawDate ? new Date(rawDate) : null;

                                        // Check if date is valid before using toISOString
                                        if (date instanceof Date && !isNaN(date)) {
                                        return date.toISOString().split('T')[0];
                                        } else {
                                        return "N/A";
                                        }
                                    })()
                                }
                            </td>
                            <td className='text-center'>{data?.companyName.name}</td>
                            <td className='text-center'>{data?.farmerId?.pump_type }, {data?.farmerId?.HP}</td>
                            <td className='text-center'>{data?.currentStatus}</td>
                            <td className='text-center'>{data?.quarterly}</td>
                            <td className='text-center'>
                                 {data?.submitDate ? new Date(data?.submitDate).toISOString().split('T')[0] : "N/A"}

                            </td>
                            <td className='text-center'>
                            {data?.image && data?.image.map((imgSrc, index) => (
                                <img
                                key={index}
                                className='rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-110 w-10 h-10 object-cover'
                                alt='surveyImage'
                                src={imgSrc.replace("http://88.222.214.93:8001/", "http://service.galosolar.com/api/")}
                                />
                            ))}
                            </td>
                        </tr>
                    ))}
                </table>
            </div>
        </div>

        {/* Modal for Image */}
      
      
   </>
  )
}



